// Badge de status de proposta (rascunho/enviada/aprovada).
// Usado por ListaGeradas e ViewerProposta. Extraído de ComercialPropostas.tsx.

export function StatusBadge({ status }: { status: string }) {
  const c: Record<string, string> = { rascunho: '#B07500', enviada: '#0930D0', aprovada: '#0a7f4a' };
  const l: Record<string, string> = { rascunho: 'Rascunho', enviada: 'Enviada', aprovada: 'Aprovada' };
  return <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 3,
    background: `${c[status] || '#888'}22`, color: c[status] || '#888', fontWeight: 500 }}>
    {l[status] || status}
  </span>;
}
